export function metadataInitialState() {
    return {
        Id: 0,
        Key: "",
        Value: "",
        Order: 0
    };
}
